import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import Root from "@/Root";
import { installResizeObserverLoopFix } from "@/utils/resizeObserverLoopFix";

// Debe correr ANTES de cualquier render, para que Radix/Recharts/etc. usen la
// versión segura de ResizeObserver desde el primer montaje.
installResizeObserverLoopFix();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
